import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import CustomButton from "../../../../Components/Button/CustomButton";
import CustomInput from "../../../../Components/input/CustomInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { GetSingleWorkout } from "../../../../APIs/Function/Workout/WorkoutPlans/GetSingleWorkout";
import { handleUpdateWorkout } from "../../../../APIs/Function/Workout/WorkoutPlans/EditWorkout";

const EditWorkoutPlans = () => {
  const [workoutData, setWorkoutData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadinga, setLoadinga] = useState(false);
  const navigate = useNavigate();
  const [tempImage, setTempImage] = useState("");
  const [selectedVideoUrl, setSelectedVideoUrl] = useState("");
  const { id } = useParams();

  const handleEditWorkout = async () => {
    setLoading(true);
    try {
      let res = await GetSingleWorkout(id);
      setLoading(false)
      setWorkoutData(res.r);
      setFormData({
        ...formData,
        title: res.r.title,
        description: res.r.description,
        image: res.r.banner_image,
        video: res.r.video,
      });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    handleEditWorkout();
  }, []);

  useEffect(() => {
    if (workoutData) {
      setFormData({
        ...formData,
        title: workoutData.title,
        description: workoutData.description,
        image: workoutData.banner_image,
        video: workoutData.video,
      });
    }
  }, [workoutData]);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: null,
    video: null,
  });
  const initialFormData = {
    title: "",
    description: "",
    image: null,
    video: null,
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (event, fileType) => {
    const file = event.target.files[0];

    if (fileType === "image") {
      const reader = new FileReader();
      reader.onload = () => {
        setTempImage(reader.result);
        setFormData({
          ...formData,
          image: file,
        });
      };
      reader.readAsDataURL(file);
    } else if (fileType === "video") {
      setFormData({
        ...formData,
        video: file,
      });

      setTimeout(() => {
        const reader = new FileReader();
        reader.onload = () => {
          setSelectedVideoUrl(reader.result);
        };
        reader.readAsDataURL(file);
      }, 2000);
    }
  };
  console.log(loading)
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      formData.title.trim() !== "" &&
      formData.description.trim() !== "" &&
      id &&
      (formData.image || formData.video)
    ) {
      try {
        setLoadinga(true);
        let res = await handleUpdateWorkout(formData, id);
        if (res.s) {
          alert("Data Edited Successfully");
          setLoadinga(false);
          navigate("/workoutplans");
        }
        setFormData(initialFormData);
      } catch (error) {
        console.log(error);
      }
    } else {
      alert("Please Fill All Required Fields");
    }
  };

  console.log(workoutData);
  return (
    <> 
     {loading  ? (
        <Box sx={{ mt: "25%" }}>
          <CircularProgress ></CircularProgress>
        </Box>
      ) : (
    <Box>
      {/* header */}
      <Box
        sx={{
          bgcolor: "#31AEF4",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: { xs: "50px", md: "70px", lg: "70px" },
          p: "10px",
          boxSizing: "border-box",
        }}
      >
        <Link to={"/workoutplans"}>
          <Box
            sx={{
              height: { xs: "50px", md: "60px", lg: "60px" },
              display: "flex",
              alignItems: "center",
            }}
          >
            <img height={"100%"} src={backbluebtn} alt="back" />
          </Box>
        </Link>
        <Box>
          <Typography
            sx={{
              fontFamily: "Open Sans",
              fontSize: { md: "30px", sm: "20px" },
              fontWeight: 600,
              lineHeight: "36px",
              color: "#FFFFFF",
            }}
          >
            Edit Details
          </Typography>
        </Box>
        <Box>
          <CustomButton
            onClick={handleSubmit}
            sx={{
              width: { xs: "40px", md: "50px", lg: "80px" },
              height: { xs: "10px", md: "50px", lg: "50px " },
            }}
          >
            {loadinga ? <CircularProgress></CircularProgress> : "Save"}
          </CustomButton>
        </Box>
      </Box>
      {/* form */}
      <Container maxWidth="sm" sx={{ mt: "30px" }}>
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomInput
                label="Title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                label="Description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                fullWidth
                multiline
                rows={4}
                required
              />
            </Grid>
            <Box sx={{ display: "flex" }}></Box>
            <Grid item xs={6}>
              <label htmlFor="file-image-input">
                <Box
                  sx={{
                    width: "100%",
                    bgcolor: "#F4F4F4",
                    p: "20px",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center ",
                    justifyContent: "center",
                    flexDirection: "column",
                    cursor: "pointer",
                  }}
                >
                  <Box sx={{ width: "200px", height: "200px" }}>
                    <img
                      width={"100%"}
                      height={"100%"}
                      className="preview"
                      src={
                        tempImage ||
                        `https://api-qhealth.equitysofttechnologies.com/upload/images/${workoutData.banner_img}`
                      }
                      alt=""
                    />
                  </Box>

                  <Typography>Upload New Banner Image</Typography>
                </Box>
              </label>
              <input
                key={`image-${formData.image}`}
                accept="image/*"
                type="file"
                id="file-image-input"
                onChange={(event) => handleFileChange(event, "image")}
                style={{ display: "none" }}
              />
            </Grid>
            <Grid item xs={6}>
              <label htmlFor="file-video-input">
                <Box
                  sx={{
                    bgcolor: "#F4F4F4",
                    p: "20px",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center ",
                    justifyContent: "center",
                    flexDirection: "column",
                    cursor: "pointer",
                  }}
                >
                  <Box>
                    {selectedVideoUrl ? (
                      <Box sx={{ width: "200px", height: "200px" }}>
                        <video
                          className="preview"
                          height={"200px"}
                          width={"200px"}
                          autoPlay
                          loop
                          controls
                          muted
                        >
                          <source src={selectedVideoUrl} type="video/mp4" />
                        </video>
                      </Box>
                    ) : (
                      workoutData?.video && (
                        <Box sx={{ width: "200px", height: "200px" }}>
                          <video
                            className="preview"
                            width={"100%"}
                            height={"100%"}
                            controls
                          >
                            <source
                              src={`https://api-qhealth.equitysofttechnologies.com/upload/video/${workoutData.video}`}
                              type="video/mp4"
                            />
                          </video>
                        </Box>
                      )
                    )}
                  </Box>

                  <Typography>Upload New Workout Video</Typography>
                </Box>
              </label>
              <input
                key={`video-${formData.video}`}
                accept="video/*"
                type="file"
                id="file-video-input"
                onChange={(event) => handleFileChange(event, "video")}
                style={{ display: "none" }}
              />
            </Grid>
          </Grid>
        </form>
      </Container></Box>)}
    </>
  );
};

export default EditWorkoutPlans;
